import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { invalidationIntents } from "~/api/cache"

import type { ExtendedWarrantySnapshotDto } from "../dto/extended-warranty.dto"
import { extendedWarrantyService } from "../services/extended-warranty.service"

export default function useUpdateExtendedWarranty(
  proposalId: string,
  designId: string,
): UseMutationResult<ExtendedWarrantySnapshotDto, unknown, number | null> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (warrantyId) =>
      extendedWarrantyService.updateSelection(proposalId, designId, {
        warrantyId,
      }),
    onSuccess: () =>
      invalidationIntents.extendedWarrantySelectionChanged(
        queryClient,
        proposalId,
      ),
  })
}
